import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  CheckDomainAvailabilityResponse,
  checkDomainAvailability as universalCheckDomainAvailability,
} from './premium-domains-v2-availability-domain-availability.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/domains' };

export function checkDomainAvailability(
  httpClient: HttpClient
): CheckDomainAvailabilitySignature {
  return (domain: string) =>
    universalCheckDomainAvailability(
      domain,
      // @ts-ignore
      { httpClient }
    );
}

interface CheckDomainAvailabilitySignature {
  /**
   * Checks whether the given domain is available for purchase.
   *
   *
   * You can purchase the specified domain in case the returned
   * `availability.available` boolean is `true`. The domain is already taken
   * when `false` is returned.
   *
   * The `domain` field must include the TLD. For example, `my-new-domain.com`.
   *
   * > __Important:__ This call requires an account level API key and cannot be authenticated with the standard authorization header.
   * @param - Domain name. Must include the TLD. For example, `my-new-domain.com`. Only
   * alphanumeric characters, hyphens, and dots are supported.
   *
   * Min: 3 characters
   * Max: 63 characters
   */
  (domain: string): Promise<
    NonNullablePaths<
      CheckDomainAvailabilityResponse,
      | `availability.domain`
      | `availability.available`
      | `availability.premium`
      | `availability.premiumType`,
      3
    >
  >;
}

export {
  CheckDomainAvailabilityRequest,
  CheckDomainAvailabilityResponse,
  DomainAvailability,
  PremiumType,
} from './premium-domains-v2-availability-domain-availability.universal.js';
